<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [cardOptionBtnValue]="'global.add_btn_text'|translate "
                [cardOptionBtnIcon]="'feather icon-plus'"
                [cardOptionBtn]="true"
                [cardRouterLink]="'/back-office/country/add'"
                [title]="'global.overview'|translate">
        <app-grid [grid]="grid" ></app-grid>
<!--        <button class="btn btn-primary ripple light pull-right my-3" (click)="goToArchive()" type="button">{{'global.view_archive'|translate}}</button>-->
      </app-card>
    </div>
  </div>
</div>
